"use client";

function normalizeTrend(trend) {
  if (trend === "up") return "increased";
  if (trend === "down") return "decreased";
  return trend ?? "unchanged";
}

function getValueTrendClass(normalizedTrend) {
  if (normalizedTrend === "increased") return "kbv-odds-value--up";
  if (normalizedTrend === "decreased") return "kbv-odds-value--down";
  return "";
}


export default function OddsMatchOuCell({ line, side, odds, trend = "unchanged" }) {
  const normalizedTrend = normalizeTrend(trend);
  const trendClass = getValueTrendClass(normalizedTrend);
  const hasArrow = normalizedTrend === "increased" || normalizedTrend === "decreased";
  const normalCellClass = !hasArrow ? "kbv-odds-cell--normal" : "";

  const leftText = side === "O" ? (line || "-") : "-";
  const rightText = odds != null && odds !== "" && odds !== "-" ? odds : "-";

  return (
    <div className={`kbv-odds-cell flex items-center justify-between p-0 h-5 leading-5 text-xs cursor-pointer relative rounded-sm ${normalCellClass} ${trendClass}`}>
      <span className="shrink-0 px-0.5 text-xs font-normal text-[color:var(--kbv-odds-label-color)] w-[34px] text-left">{leftText}</span>
      <span className="flex-1 text-center text-xs font-bold text-[color:var(--kbv-odds-value-color)]">{side}</span>
      <span className={`min-w-0 shrink-0 pl-[2px] pr-[14px] text-xs font-bold text-[color:var(--kbv-odds-value-color)] relative w-[48px] text-right ${trendClass}`}>
        <strong>{rightText}</strong>
      </span>
    </div>
  );
}
